export function setToken(token: string) {
  localStorage.setItem("token", token);
}
export function deleteToken() {
  localStorage.removeItem("token");
}

export const getIsSignedIn = () => {
  return !!localStorage.getItem("token");
};
